import { useMemo } from 'react';
import { EntityMenuActions } from '../../../../../../../edge/entity-actions/components/entity-menu-actions/EntityMenuActions';
import {
  EntityAction,
  EntityActionHandlerType,
  EntityActionType
} from '../../../../../../../edge/entity-actions/interfaces/entity-actions';
import { IWorkspace } from '../../../../interfaces/workspace';
import useHasPermission from '../../../../../../../access-control/hooks/useHasPermission';
import { RbacPermissions } from '../../../../../../../core/interfaces/user';
import { RBAC_DISABLED_MESSAGE } from '../../../../../../../access-control/constants/strings';

enum WorkspaceAction {
  DELETE = 'DELETE'
}

interface WorkspaceActionMenuProps {
  workspace: IWorkspace;
  onDeleteClick: (workspace: IWorkspace) => void;
}

export function WorkspaceActionMenu({ workspace, onDeleteClick }: WorkspaceActionMenuProps) {
  const { hasPermission, isRbacEnabled } = useHasPermission();
  const canDelete = !isRbacEnabled || hasPermission(RbacPermissions.TEAM_DELETE);

  const actions: EntityAction<WorkspaceAction>[] = useMemo(() => [
    {
      action: WorkspaceAction.DELETE,
      type: EntityActionType.MENU,
      actionHandlerType: EntityActionHandlerType.CUSTOM,
      displayName: 'Delete',
      icon: 'delete',
      iconSize: 1,
      destructive: true,
      disabled: !canDelete,
      disabledReason: !canDelete ? RBAC_DISABLED_MESSAGE : undefined
    }
  ], [canDelete]);

  const handleActionClick = (action: EntityAction<WorkspaceAction>) => {
    if (action.action === WorkspaceAction.DELETE) {
      onDeleteClick(workspace);
    }
  };

  return (
    <EntityMenuActions
      actions={actions}
      onActionClick={handleActionClick}
      menuLabel='Workspace Actions'
    />
  );
}
